const UPDATE_CAROUSEL_STATE = '@@UPDATE_CAROUSEL_STATE';

export function updateCarouselState({ carouselIndex, carouselMoving }) {
  return {
    type: UPDATE_CAROUSEL_STATE,
    carouselIndex,
    carouselMoving,
  };
}

export function mediaReducer(state = {
  carouselIndex: null,
  carouselMoving: false
}, action) {
  switch (action.type) {
    case UPDATE_CAROUSEL_STATE:
      return {...state, carouselIndex: action.carouselIndex, carouselMoving: action.carouselMoving};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ../src/client/state/media.js